import "@fontsource/barlow-condensed/400.css";
import "@fontsource/barlow-condensed/700.css";
import "@fontsource/barlow-condensed/900.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import BrisbaneRegion from "./pages/BrisbaneRegion";
import WideBayRegion from "./pages/WideBayRegion";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/brisbane" element={<BrisbaneRegion />} />
          <Route path="/wide-bay" element={<WideBayRegion />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
